<script>
export default {
  props: {
    isVisible: {
      type: Boolean,
      default:false
    },
  },
  data: () => ({
  }),
};
</script>
<template>
  <v-banner
    v-if="isVisible"
    color="success"
    stacked >
    <template #icon>
      <v-icon color="white">mdi-vector-arrange-below</v-icon>
    </template>
    <template #default>
      <div style="color:white">
        <p class="merge-count-title">{{$t('component.documentValidation.mergeCountHint.title')}}</p>
        <p class="merge-count-text">{{$t('component.documentValidation.mergeCountHint.text')}}</p>
      </div>
    </template>
  </v-banner>
</template>
<style scoped>
.merge-count-title {
  font-size: 16px;
  text-decoration: underline;
  margin: 0;
}
.merge-count-text {
  font-size: 14px;
  text-decoration: none;
  margin: 0;
  font-weight: 300;
}
div.v-banner.v-sheet.theme--light{
  border-radius:8px;
}
div.v-banner__wrapper{
  padding: 8px 16px!important;
}
</style>
